import { BrowserCacheLocation, IPublicClientApplication, LogLevel, PublicClientApplication } from '@azure/msal-browser';

import { environment } from '../../../../environments/environment';

export function msalInstanceFactory(): IPublicClientApplication {
  const redirectUri = resolveLocaleAwareUri(environment.auth.redirectUri);
  const postLogoutRedirectUri = resolveLocaleAwareUri(environment.auth.postLogoutRedirectUri);

  return new PublicClientApplication({
    auth: {
      clientId: environment.auth.clientId,
      authority: environment.auth.authority,
      redirectUri,
      postLogoutRedirectUri
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage
    },
    system: {
      allowPlatformBroker: false,
      loggerOptions: {
        loggerCallback: (_logLevel: LogLevel, _message: string) => undefined,
        logLevel: LogLevel.Warning,
        piiLoggingEnabled: false
      }
    }
  });
}

function resolveUri(uri: string): string {
  if (/^https?:\/\//i.test(uri)) {
    return uri;
  }

  return new URL(uri, window.location.origin).toString();
}

function normalizeAbsoluteUri(uri: URL): string {
  const pathname = uri.pathname === '/' ? '' : uri.pathname.replace(/\/$/, '');

  return `${uri.origin}${pathname}${uri.search}${uri.hash}`;
}

function resolveLocaleAwareUri(uri: string): string {
  const resolvedUri = new URL(resolveUri(uri));

  if (resolvedUri.origin !== window.location.origin) {
    return normalizeAbsoluteUri(resolvedUri);
  }

  const localeMatch = window.location.pathname.match(/^\/(en-ca|fr-ca)(?=\/|$)/i);
  const routeLocale = localeMatch?.[1]?.toLowerCase();

  if (!routeLocale || /^(\/en-ca|\/fr-ca)(\/|$)/i.test(resolvedUri.pathname)) {
    return normalizeAbsoluteUri(resolvedUri);
  }

  const basePath = resolvedUri.pathname === '/' ? '' : resolvedUri.pathname.replace(/\/$/, '');
  resolvedUri.pathname = `/${routeLocale}${basePath}` || `/${routeLocale}`;

  return normalizeAbsoluteUri(resolvedUri);
}